export const baseConfig = {
    "signalrLink": "https://wuincyyrmjsd666signalr.aidixinbj.com",
    "rechargeFlag": true,
    "bindCardFlag": true,
    "year": 2019
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/config.js
// module id = 1033
// module chunks = 75